import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const useBackCountStore = defineStore('backCount', () => {
  const backCount = ref<number>(0)

  const addBackCount = (count: number) => {
    backCount.value += count
  }
  const clearBackCount = (): void => {
    backCount.value = 0
  }
  const isPossibleBack = computed<boolean>(() => {
    return backCount.value !== 0
  })

  const reset = () => {
    backCount.value = 0
  }

  return {
    backCount,
    isPossibleBack,
    addBackCount,
    clearBackCount,
    reset,
  }
})

export { useBackCountStore }
